import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {BRAND} from '../settings/dashboardStyles';

const useStyles = makeStyles(() => ({
    root: {
        position: 'absolute',
        inset: 0,
        zIndex: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(247, 244, 238, 0.58)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        pointerEvents: 'all',
    },
    panel: {
        minWidth: 210,
        padding: '24px 32px',
        borderRadius: 14,
        background: '#fbfaf7',
        border: `1px solid ${BRAND.goldSoft}`,
        boxShadow: '0 18px 50px rgba(30, 53, 83, 0.22)',
        color: BRAND.deep,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
        fontWeight: 600,
        letterSpacing: 0.2,
        textAlign: 'center',
    },
    spinner: {
        width: 44,
        height: 44,
        borderRadius: '50%',
        border: `4px solid rgba(176, 141, 87, 0.25)`,
        borderTopColor: BRAND.gold,
        animation: '$spin 0.9s linear infinite',
    },
    '@keyframes spin': {
        to: {transform: 'rotate(360deg)'},
    },
}));

export default function LoadingOverlay({label = 'Načítavam...'}) {
    const classes = useStyles();

    return (
        <div className={classes.root} role="status" aria-live="polite" aria-label={label}>
            <div className={classes.panel}>
                <div className={classes.spinner}/>
                <span>{label}</span>
            </div>
        </div>
    );
}
